import { adminServerInstance } from "../axios/instances";
import {     
    GET_ALL_COMPLAINTS,
    GET_ALL_COMPLAINTS_SUCCESS,
    GET_ALL_COMPLAINTS_FAIL
 } from './types';

export function getAllComplaints(start_time, end_time) {   
    return function(dispatch) {
        dispatch({type: GET_ALL_COMPLAINTS})
        return adminServerInstance.get(`/business/getallcomplaints?start_time=${start_time}&end_time=${end_time}`)
        .then(({data}) => {
            dispatch({
                type: GET_ALL_COMPLAINTS_SUCCESS,
                payload: data.data
            })
            return Promise.resolve(data.data);
        }).catch(error => {
            dispatch({
                type: GET_ALL_COMPLAINTS_FAIL,
                payload: error
            })
            return Promise.reject(error);
        });
    }
}

